import { FaStar } from "react-icons/fa";

const StarDisplay = ({ rating }) => {
  return (
    <div style={{ display: "flex", gap: "4px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <FaStar
          key={star} 
          size={18}
          // color={star <= rating ? "#ffc107" : "#e4e5e9"}
          className={star <= rating ? "#ffc107" : "#e4e5e9"}
        />
      ))}
    </div>
  );
};

export default StarDisplay;
